import { createContext, useContext, useState, useCallback } from "react";

const CURRENCIES = [
  { code: "CLP", symbol: "$", name: "Peso Chileno", rate: 1, locale: "es-CL", decimals: 0 },
  { code: "ARS", symbol: "AR$", name: "Peso Argentino", rate: 1.35, locale: "es-AR", decimals: 0 },
  { code: "USD", symbol: "US$", name: "Dolar EEUU", rate: 0.00105, locale: "en-US", decimals: 2 },
  { code: "EUR", symbol: "\u20ac", name: "Euro", rate: 0.00091, locale: "de-DE", decimals: 2 },
];

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [currencyCode, setCurrencyCode] = useState(() => localStorage.getItem("pv_currency") || "CLP");

  const currency = CURRENCIES.find(c => c.code === currencyCode) || CURRENCIES[0];

  const changeCurrency = useCallback((code) => {
    setCurrencyCode(code);
    localStorage.setItem("pv_currency", code);
  }, []);

  const formatPrice = useCallback((clpAmount) => {
    if (clpAmount === 0) return currency.code === "CLP" ? "$0" : `${currency.symbol}0`;
    const converted = clpAmount * currency.rate;
    const formatted = converted.toLocaleString(currency.locale, {
      minimumFractionDigits: currency.decimals,
      maximumFractionDigits: currency.decimals,
    });
    return `${currency.symbol}${formatted}`;
  }, [currency]);

  return (
    <CurrencyContext.Provider value={{ currency, changeCurrency, formatPrice, currencies: CURRENCIES }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export function useCurrency() {
  const ctx = useContext(CurrencyContext);
  if (!ctx) throw new Error("useCurrency must be used within CurrencyProvider");
  return ctx;
}
